import { AuthorRole } from './AuthorRole'

export default class FreeAuthor extends AuthorRole {
  // create: string[] = [...baseAuthorCRUDModels.splice(baseAuthorCRUDModels.indexOf('message'), 1)]
  create: string [] = ['pen-name', 'book', 'arc-team', 'arc', 'review', 'category']
}
